/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./HousekeepingContent2.css";

/* ==== IMAGES (use real icons here) ==== */
import IconTrusted from "../../Image/HouseKeeping/Housekeeping1.png";
import IconCoverage from "../../Image/HouseKeeping/Housekeeping1.png";
import IconCompliance from "../../Image/HouseKeeping/Housekeeping1.png";


const GuestHouseContent = () => {
  return (
    <div>
    <section className="hk2-wrapper">

      {/* TAG */}
      <div className="hk2-tag">About This Service</div>

      {/* TITLE */}
      <h2 className="hk2-title">Guest House & Staff Accommodation Management</h2>
      <div className="hk2-underline"></div>

      {/* CONTENT BOX */}
      <div className="hk2-box">
        <p>
         We fully manage corporate guest houses, ensuring professional hospitality and round-the-clock upkeep. We take full responsibility for corporate guest houses and accommodation facilities — from room cleanliness and linen services to kitchen operations, front-desk management and inventory control.
        </p>

        <p>
          Our hospitality-trained staff ensures that every visitor enjoys a comfortable, organised and well-serviced stay that reflects your organisation's standards and enhances your corporate image.
        </p>

        <p>
         From executive guest houses to staff quarters, we provide comprehensive management that ensures smooth operations and exceptional guest experiences.
        </p>
      </div>

      {/* ICON 3 CARDS (IMAGE LEFT, TEXT RIGHT) */}
      <div className="hk2-icons">

        <div className="hk2-card">
          <div className="hk2-left">
            <div className="hk2-icon-wrap">
              <img src={IconTrusted} className="hk2-icon-img" alt="Trusted Service" />
            </div>
          </div>
          <div className="hk2-right">
            <h4>Trusted Service</h4>
            <p>Since 2019</p>
          </div>
        </div>

        <div className="hk2-card">
          <div className="hk2-left">
            <div className="hk2-icon-wrap">
              <img src={IconCoverage} className="hk2-icon-img" alt="Coverage" />
            </div>
          </div>
          <div className="hk2-right">
            <h4>Coverage</h4>
            <p>15 Cities</p>
          </div>
        </div>

        <div className="hk2-card">
          <div className="hk2-left">
            <div className="hk2-icon-wrap">
              <img src={IconCompliance} className="hk2-icon-img" alt="Compliance" />
            </div>
          </div>
          <div className="hk2-right">
            <h4>Compliance</h4>
            <p>100% Certified</p>
          </div>
        </div>

      </div>

    </section>
   
    </div>
  );
};

export default GuestHouseContent;
